<template>
  <div class="container">
    <div class="student">
      <h1 class="stu-name">{{ data.userName }}</h1>
      <span class="stu-report-time">{{ data.showStartDate }} {{ data.type !== 1 ? '至' : ' ' }} {{
          data.showEndDate
        }}学习报告</span>
    </div>
    <div class="section box-style" v-if="data.todayData == 1">
      <h3 class="section-title">{{ timeType }}学习情况</h3>
      <div class="study-situation">
        <div class="situation-item">
          <span>
            <em>{{ data.number > 0 ? Math.floor(data.number / 60) : '0' }} </em> 时
            <em>{{ data.number > 0 ? parseInt(data.number % 60) : '0' }} </em> 分
          </span>
          <span>{{ timeType }}学习时长</span>
        </div>
        <div class="situation-item">
<!--          <span><em>{{ data.courseCount }}</em>次</span>-->
          <span><em>{{ data.courses.length }}</em> 讲</span>
          <span>有效学习课程</span>
        </div>
        <div class="situation-item"  v-if="data.correctly===1">
          <span v-if="data.correctTate!==null"><em>{{ data.correctTate > 0 ? (data.correctTate * 100).toFixed(0) : 0 }}%</em></span>
          <span v-if="data.correctTate ==null"><em>--</em></span>
          <span>习题正确率</span>
        </div>
      </div>
      <!-- <div id="weeklyChart" v-if="data.type !== 1"></div> -->
    </div>
    <div class="section box-style" v-if="data.type !== 1">
      <p class="publicity-text">{{ data.studentContent }}</p>
      <div class="publicity-img">
        <img :src="item.url" alt="" v-for="(item, index) in data.studentFiles" :key="index">
      </div>
    </div>
    <div class="section box-style">
      <h3 class="section-title" v-if="data.weekSort == 1">{{ type == 3 ? '本月' : '本周' }}学习时长TOP3</h3>
      <div class="top-three">
        <div v-if="data.weekSort == 1">
          <div v-for="(item, index) in data.topList" :key="index" class="top-three-list">
            <span>NO.{{ index + 1 }}</span>
            <span>{{ item.userName ? changeName(item.userName) : '--' }}</span>
            <span class="progress-box"><em class="progress" :style="{ width: item.progress + '%' }"></em></span>
            <span>{{ item.number > 0 ? MMtoMin(item.number) : '0时0分' }}</span>
          </div>
        </div>
        <div class="personal" v-if="data.histoyData == 1">
          <div class="top-three-list">
            <span>NO.{{ data.sort }}</span>
            <span>{{ data.userName }}</span>
            <span class="progress-box"><em class="progress" :style="{ width: personalProgress + '%' }"></em></span>
            <span>{{ data.number > 0 ? MMtoMin(data.number) : '0时0分' }}</span>
          </div>
          <div class="count-time" v-if="data.totalNumber!==null">历史累计学习：{{ countTime }}</div>
        </div>
      </div>
    </div>
    <div class="study-content" v-if="data.type == 1 && data.studyData == 1">
      <div class="section swiper-container " id="swiper">
        <div class="title">
          <h3 class="section-title  study-section">学习课程<em class="count-num">{{ data.courses && data.courses.length }}</em>讲
          </h3>
        </div>
        <div class="expendStudy">
          <div class="study-content-list" v-for="(item, index) in data.courses" :key="index">
            <div class="course">
              <span>{{ item.subjectName }}</span>
              <span> {{ item.teacherName }} · {{ item.className }}</span>
            </div>
            <div class="study-content-title">
              {{ item.courseName }}</div>
            <div class="el-row--flex is-justify-space-around">

              <div class="study-content-item">
                <div>
                  <svg t="1720963231876" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="37389" width="32" height="32"><path d="M512 12.8C236.7488 12.8 12.8 236.7488 12.8 512s223.9488 499.2 499.2 499.2a496.384 496.384 0 0 0 448.3072-279.296 38.4 38.4 0 0 0-68.9664-33.8944A420.0448 420.0448 0 0 1 512 934.4c-232.9088 0-422.4-189.4912-422.4-422.4S279.0912 89.6 512 89.6s422.4 189.4912 422.4 422.4a38.4 38.4 0 0 0 76.8 0c0-275.2512-223.9488-499.2-499.2-499.2z" fill="#dc5048" p-id="37390"></path><path d="M766.976 503.3984m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z" fill="#dc5048" p-id="37391"></path><path d="M511.9488 145.0496a38.4 38.4 0 0 0-38.4 38.4v328.4992c0 21.1968 17.2032 38.4 38.4 38.4h117.4016a38.4 38.4 0 0 0 0-76.8h-79.0016V183.4496a38.4 38.4 0 0 0-38.4-38.4z" fill="#dc5048" p-id="37392"></path></svg>
                </div>
                <div>
                  <div class="study-value">{{ item.seconds > 0 ? MMtoDayHourMin(item.seconds) : '0分钟' }}</div>
                  <div><em>在线学习</em></div>
                </div>
              </div>


              <div class="study-content-item" v-if="data.correctly===1">
                <div>
                  <svg t="1720961942154" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                       p-id="12794" width="34" height="34">
                    <path d="M759.466667 989.866667h-494.933334c-78.506667 0-141.653333-63.146667-141.653333-141.653334V175.786667c0-78.506667 63.146667-141.653333 141.653333-141.653334h494.933334c78.506667 0 141.653333 63.146667 141.653333 141.653334v670.72c0 80.213333-63.146667 143.36-141.653333 143.36z m-494.933334-904.533334c-49.493333 0-90.453333 40.96-90.453333 90.453334v670.72c0 49.493333 40.96 90.453333 90.453333 90.453333h494.933334c49.493333 0 90.453333-40.96 90.453333-90.453333V175.786667c0-49.493333-40.96-90.453333-90.453333-90.453334h-494.933334z"
                          fill="#dc5048" p-id="12795"></path>
                    <path d="M747.52 756.053333H295.253333c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h450.56c13.653333 0 25.6 11.946667 25.6 25.6s-10.24 25.6-23.893333 25.6zM501.76 576.853333H295.253333c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h206.506667c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6zM331.093333 486.4c-20.48-5.12-27.306667-15.36-20.48-32.426667l117.76-274.773333c6.826667-15.36 20.48-22.186667 40.96-22.186667h15.36c20.48 0 34.133333 6.826667 40.96 22.186667l117.76 273.066667c6.826667 17.066667 0 29.013333-22.186666 34.133333-22.186667 5.12-35.84 0-42.666667-18.773333l-27.306667-71.68c1.706667-1.706667-1.706667-3.413333-5.12-3.413334h-136.533333c-3.413333 0-6.826667 1.706667-6.826667 3.413334L375.466667 467.626667c-8.533333 18.773333-22.186667 23.893333-44.373334 18.773333z m88.746667-136.533333c0 1.706667 0 1.706667 1.706667 1.706666h110.933333c1.706667 0 3.413333 0 1.706667-1.706666l-54.613334-148.48c-1.706667-3.413333-1.706667-3.413333-3.413333-3.413334s-1.706667 1.706667-3.413333 3.413334c-10.24 30.72-22.186667 64.853333-39.253334 105.813333l-13.653333 42.666667zM669.013333 286.72c-11.946667 0-18.773333-8.533333-18.773333-23.893333v-35.84c0-1.706667 0-1.706667-1.706667-1.706667h-32.426666c-17.066667 0-23.893333-6.826667-23.893334-18.773333 0-11.946667 8.533333-18.773333 23.893334-18.773334H648.533333c1.706667 0 1.706667 0 1.706667-1.706666v-34.133334c0-17.066667 6.826667-23.893333 18.773333-23.893333 11.946667 0 18.773333 8.533333 18.773334 23.893333V187.733333c0 1.706667 0 1.706667 1.706666 1.706667h32.426667c17.066667 0 23.893333 6.826667 23.893333 18.773333 0 11.946667-8.533333 18.773333-23.893333 18.773334h-32.426667c-1.706667 0-1.706667 0-1.706666 1.706666v35.84c0 13.653333-5.12 22.186667-18.773334 22.186667z"
                          fill="#dc5048" p-id="12796"></path>
                  </svg>
                </div>
                <div>
                  <div v-if="item.correctTate!==null" class="study-value">
                    <em>{{ item.correctTate > 0 ? (item.correctTate * 100).toFixed(0) + '%' : '--' }}</em></div>
                  <div v-else class="study-value"><em>--</em></div>
                  <div><em>习题正确率</em></div>
                </div>
              </div>

              <div class="study-content-item"  v-if="item.otherCorrectTate!==null && data.correctly===1">
                <div>
                  <svg t="1720962611351" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="36232" width="34" height="34"><path d="M861.34784 734.28992a25.6 25.6 0 0 1 1.29024 36.18816l-123.78112 132.97664a139.03872 139.03872 0 0 1-0.59392 0.6144l-1.024 1.024a46.08 46.08 0 0 1-65.1264-0.90112l-63.1808-64.9216a25.6 25.6 0 1 1 36.70016-35.69664l59.392 61.0304 120.13568-129.024a25.6 25.6 0 0 1 36.18816-1.29024zM471.04 122.88c124.416 0 225.28 100.864 225.28 225.28 0 81.87904-43.68384 153.55904-109.03552 193.00352 28.30336 10.99776 55.64416 26.56256 81.92 46.73536a25.6 25.6 0 1 1-31.1296 40.63232c-46.20288-35.4304-95.4368-54.0672-148.35712-55.9104a210.41152 210.41152 0 0 1-28.09856 0.6144c-31.47776 2.31424-64.24576 10.30144-98.42688 23.9616-102.4 40.96-158.16704 119.808-169.2672 240.37376a25.6 25.6 0 0 1-50.97472-4.68992c12.8-139.264 80.4864-234.94656 201.23648-283.21792 5.12-2.048 10.17856-3.97312 15.2576-5.77536A225.13664 225.13664 0 0 1 245.76 348.16c0-124.416 100.864-225.28 225.28-225.28z m0 51.2a174.08 174.08 0 0 0-9.91232 347.87328c9.1136-0.6144 18.14528-0.77824 27.09504-0.57344A174.08 174.08 0 0 0 471.04 174.08z" fill="#dc5048" p-id="36233"></path></svg>
                </div>
                <div>
                  <div class="study-value"><em>

                    {{ item.otherCorrectTate > 0 ? (item.otherCorrectTate * 100).toFixed(0) + '%' : '--' }}</em>
                  </div>
                  <div><em>他人正确率</em></div>
                </div>
              </div>
            </div>
<!--            <div class="course">-->
<!--              {{ item.teacherName }}·{{ item.className }}-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="section study-content" v-if="data.type !== 1 && data.studyContent == 1">
      <h3 class="section-title">学习内容<em class="count-num">{{ data.courses && data.courses.length }}</em>次</h3>
      <div class="box-style">
        <div class="study-list" v-for="(item, index) in data.courses" :key="index">
          <div class="study-title"><span><em>{{ item.subjectName }}</em>{{ item.courseName }}</span><span>{{
              item.seconds > 0 ? MMtoDayHourMin(item.seconds) : '0分钟'
            }}</span></div>
        </div>
      </div>
    </div>
    <div class="section counselor-suggest">
      <div class="suggest-content box-style">
        <div class="counselor-title">
          <img :src="data.companyLogo" alt="" class="counselor-avatar" v-if="data.companyLogo">
          <img src="@/assets/images/logo.png" alt="" class="counselor-avatar" v-else>
          <span class="counselor-info">
          <span><em class="counselor-company">{{ data.feedbackCompany }}</em> | <em>{{ data.feedbackPerson }}</em></span>
          <span>{{ data.feedbackDate }}</span>
        </span>
        </div>
        <div class="rate">
          <span>整体表现：</span>
          <el-rate v-model="data.score" disabled show-score text-color="#ff8d1a" score-template="{value}">
          </el-rate>
        </div>
        <div class="content-box">
          <div>{{ data.feedbackContent }}</div>
          <img :src="item.url" alt="" v-for="(item, index) in data.files" :key="index" />
        </div>
        <div class="expand-data" v-if="data.expandData == 1&& data.otherFiles && data.otherFiles.length>0">
          <h3>练习&拓展资料</h3>
          <div class="data-list" v-for="(item, index) in data.otherFiles" :key="index" @click="toExpandData(item.url)">
            <span>{{ item.type == 1 ? '讲义' : '习题' }}:</span>
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="read-btn">
      <button type="button" class="btn">已&nbsp;读</button>
    </div>
  </div>
</template>
<script>
import { getReport } from '../request/api'
import * as echarts from 'echarts'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'

export default {
  name: '',
  data() {
    return {
      type: 1, // 1:日报，2：周报，3：月报
      timeType: '',
      countTime: '12小时1分',
      // 本周学习时长
      value: 3.7,
      data: {},
      swiper: null,
      toggleStudy: true, // 是否展开学习板块
      personalProgress: 0
    }
  },
  watch: {
    'data.type': {
      deep: true,
      handler(newV, oldV) {
        this.timeType = newV == 1 ? '今日' : newV == 2 ? '本周' : '本月'
      }
    }
  },
  mounted() {
    const feedBackId = this.getUrlParams()
    this.handleGetReport(feedBackId)
  },
  methods: {
    changeName(name) {
      if (name && name.length == 2) {
        return name.charAt(0) + '*'
      }
      else if (name && name.length == 3) {
        return name.charAt(0) + '*' + name.charAt(2)
      }
      else if (name && name.length > 3) {
        let nameChart = ''
        for (let i = 0; i < name.length; i++) {
          if (i <= 2) {
            nameChart += name.charAt(i)
          }
          else {
            nameChart += '*'
          }
        }
        return nameChart
      }
    },
    //获取地址栏参数
    getUrlParams() {
      let url = window.location.href//获职urL中"”?”符后的字串let paramsObj = new Object();
      let feedBackId = 0
      if (url.indexOf('?') != -1) {
        const params = url.split('?')
        feedBackId = params[1].split('=')[1]
        return feedBackId
      }
    },
    MMtoMin(min) {
      var hour = Math.floor(min / 60)
      var minute = parseInt(min % 60)
      if(hour===0){
        return minute + '分钟'
      }
      if(minute===0){
        return hour + '小时'
      }
      return hour + '时' + minute + '分'
    },
    MMtoDayHourMin(seconds) {
      let minutes = Math.floor(seconds / 60)
      let remainingSeconds = seconds % 60
      if(remainingSeconds===0){
        return minutes + '分钟'
      }
      return minutes + '分' + remainingSeconds + '秒'
    },
    handleGetReport(feedBackId) {
      getReport({ feedbackId: feedBackId }).then(res => {
        if (res.code == '000000') {
          // 个人历史累计时长
          this.countTime = res.data.totalNumber > 0 ? this.MMtoMin(res.data.totalNumber) : '0时0分'
          if (res.data.topList && res.data.topList.length > 0) {
            res.data.topList.forEach(item => {
              // 排名前三的看课时长占比，以第一个人的时长为100%
              item.progress = parseFloat(item.number / res.data.topList[0].number) * 100
            })
            // 个人的看课时长占比
            this.personalProgress = parseFloat(res.data.number / res.data.topList[0].number) * 100
          }
          // res.data.type = 1
          this.data = res.data || {}
          // this.data.files 为图片对象，需要将每个对象中的url属性拼接阿里云图片压缩地址
          if (res.data.files && res.data.files.length > 0) {
            res.data.files.forEach(item => {
              item.url = item.url + '?x-oss-process=image/resize,w_750/quality,Q_70'
            })
          }
          // this.data.courses 中每一项中，如果courseId相同则合并，并且 seconds 属性进行累加

          if (res.data.courses && res.data.courses.length > 0) {
            let courseList = []
            res.data.courses.forEach(item => {
              item.seconds=Math.floor(item.seconds / 60)*60
              let course = courseList.find(course => course.courseId == item.courseId)
              if (course) {
                course.seconds += item.seconds
              }
              else {
                courseList.push(item)
              }
            })
            res.data.courses = courseList
          }

          //this.initBarChart(res.data.days)

          // setTimeout(() => {
          //   this.initSwiper()
          // }, 1000)
        }
      })
    },
    initBarChart(data) { // 本周学习时长柱状图
      var myChart = echarts.init(document.getElementById('weeklyChart'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          // formatter: (params) => {
          //   return params.name + ":" + this.weekly[params.dataIndex]
          // }
        },
        grid: {
          top: 20,
          left: 0,
          right: 0,
          bottom: 20
        },
        xAxis: {
          data: data.map(item => item.week),
          axisTick: {
            show: false
          },
          axisLine: { show: false }
        },
        yAxis: {
          show: false
        },
        series: [
          {
            name: '学习时长',
            type: 'bar',
            data: data.map(item => item.number),
            barWidth: 20,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#de4743' },
                { offset: 0.5, color: '#eb645c' },
                { offset: 1, color: '#f78174' }
              ]),
              borderRadius: 4
            },
          }
        ]
      })
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    // 初始化轮播图
    initSwiper() {
      let options = {
        spaceBetween: 10,
        autoplay: true,
        loop: true,
      }
      this.swiper = new Swiper('#swiper', options)
    },
    toggle() {
      if (this.toggleStudy) {
        this.swiper.autoplay.start()
      }
      else {
        this.swiper.autoplay.stop()
      }
      this.toggleStudy = !this.toggleStudy
    },
    toExpandData(link) {
      window.location.href = link
    }
  },
  destroyed() {

  },
}
</script>
<style scoped>
.container {
    position: relative;
    width: 100%;
    background: #f1f1f1 url(../assets/images/bg.png) no-repeat center top;
    background-size: 100% auto;
    padding: 80px 0 80px 0;
    overflow-y: auto;
    max-width: 375px;
    margin: 0 auto;
}

.student {
    color: white;
    margin-left: 18px;
}

.stu-name {
    margin-bottom: 10px;
    padding-left: 10px;
}

.stu-report-time {
    font-size: 18px;
    background: #00000038;
    padding: 3px 15px;
    border-radius: 8px;
}

.section {
    width: calc(100% - 15px);
    margin: 10px auto 0;
}

.box-style {
    padding: 20px 15px;
    background: #fff;
    border-radius: 10px;
}

.section-title {
    margin-bottom: 10px;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0 10px 0 5px;
}

.study-section {
    padding-left: 10px;
    margin: 7px 0 5px 0;
}

.study-situation {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.situation-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(33.3% - 5px);
    border-radius: 10px;
    background: #fff5f5;
    padding: 10px 0;
}

.situation-item > span:first-child {
    margin-bottom: 10px;
}

.situation-item em {
    color: #d43030;
    font-weight: bold;
    font-size: 16px;
}

#weeklyChart {
    width: 100%;
    height: 200px;
}

.top-three-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.top-three-list span {
    flex-shrink: 0;
}

.top-three-list span:first-child {
    min-width: 11%;
}

.top-three-list span:nth-child(2) {
    width: 46px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.top-three-list span:nth-child(3) {
    width: 40%;
}

.top-three-list span:last-child {
    width: 25%;
    text-align: right;
}

.progress {
    display: block;
    width: 0%;
    height: 10px;
    border-radius: 10px;
    background: linear-gradient(to right, #f78174, #de4743);
    transition: all ease-in-out .4s;
}

.personal {
    position: relative;
    border-radius: 10px;
    padding: 10px 0;
}

.personal:after {
    content: "";
    position: absolute;
    left: -10px;
    right: -10px;
    top: 0;
    bottom: 0;
    border-radius: 10px;
    z-index: 0;
    background: #f8f8f8;
}

.personal span {
    color: #d43030;
    z-index: 1;
}

.count-time {
    position: relative;
    z-index: 1;
}

.read-btn {
    position: fixed;
    z-index: 9;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    padding: 10px 20px;
    max-width: 375px;
    margin: 0 auto;
}

.btn {
    width: 100%;
    color: white;
    background: #d43030;
    border-radius: 45px;
    height: 45px;
}

.rate {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bolder;
    margin-top: 8px;
    margin-bottom: 8px;
}

.content-box {
    line-height: 1.8;
    font-size: 14px;
}

.content-box > div {
    white-space: pre-line;
}

.content-box img {
    max-width: 100%;
    margin: 5px 0 0;
    border-radius: 10px;
}

.content-box video {
    width: 100%;
    height: 260px;
}

.counselor-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.counselor-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
}

.counselor-info {
    display: flex;
    flex-direction: column;
}

.counselor-info span:first-child {
    font-size: 14px;
    margin-bottom: 1px;
}

.counselor-info span:last-child {
    font-size: 12px;
    color: #999;
}

.counselor-company {
    font-weight: bold;
}

.count-num {
    font-weight: bold;
    color: #d43030;
    padding: 0 5px;
}

.expand-data {
    margin-top: 15px;
    border-top: 1px solid #f2f2f2;
    padding-top: 15px;
    font-size: 14px;
}

.data-list {
    color: #0e78f0;
    text-decoration: underline;
    padding-top: 15px;
}

.study-content {
    overflow: hidden;
}

.study-content-list {
    background: #fff;
    border-radius: 10px;
    padding: 0 0 10px;
    position: relative;
    margin-bottom: 10px;
    border: 1px solid #de4743;
    box-sizing: border-box;
}

.study-content-list svg {
    width: 32px;
    height: 32px;
    margin-right: 8px;
}

.study-content-title {
    font-size: 14px;
    width: 100%;
    padding:3px 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-bottom: 1px solid #f3f3f3cc;
}

.study-content-title em {
    color: #fff;
    padding: 0 5px;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 10px;
    background: #de4743;
}
.course{
    background: linear-gradient(to right, #f78174, #de4743);
    //background: #CA2824;
    text-align: right;
    color: #fff;
    border-radius: 10px 10px 0 0;
    padding:3px 15px;
    display: flex;
    justify-content: space-between;
}


.study-content-accuracy {
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-radius: 5px;
}

.study-content-accuracy span {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.study-content-count {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.study-content-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 10px;
}

.study-content-item em {
}

.study-value {
    font-size: 14px;
    font-weight: bold;
}

.study-list {
    width: 100%;
}

.study-list:not(:last-child) {
    margin-bottom: 20px;
}

.study-title {
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
  align-items: center;
}

.study-title span:first-child {
    font-size: 14px;
    line-height: 1.5;
}

.study-title span:last-child {
    text-align: right;
}

.study-title em {
    border: 1px solid #0e78f0;
    color: #0e78f0;
    padding: 0 5px;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 10px;
}

.publicity-text {
    margin-bottom: 10px;
    font-size: 14px;
}

.publicity-img {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.publicity-img > img,
.publicity-img > video {
    width: calc(33.3% - 8px);
    border-radius: 6px;
    margin-right: 12px;
}

.publicity-img img:nth-child(3n) {
    margin-right: 0;
}

.publicity-img img:nth-child(-n + 3) {
    margin-bottom: 10px;
}

.publicity-img > video {
    height: 130px;
}
</style>



// WEBPACK FOOTER //
// src/views/daily.vue